'use client';
import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { GridLayout, GridTemplateAreas, GridVariables } from '@styles/GridVariables';
import { Spacers } from '@styles/theme';

export const PageContent = styled.div`
  grid-area: content;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const PageGrid = styled.div<{ $marginTopLarge?: boolean }>`
  ${GridVariables};

  display: grid;
  flex: 1;
  grid-template-areas: ${GridTemplateAreas.mobile};
  grid-template-columns: ${GridLayout.mobile.columns};
  padding-bottom: ${(props) => `calc(${props.theme.dimensions.footerHeight} + ${Spacers.LG}rem)`};

  ${breakpoints.desktopOrBigger} {
    grid-template-columns: ${GridLayout.desktop.columns};
    gap: ${GridLayout.desktop.gap};
    grid-template-areas: ${GridTemplateAreas.desktop};
    margin-top: ${(props) => (props.$marginTopLarge !== false ? Spacers.XXL : Spacers.LG)}rem;
  }
`;

export const PageBottom = styled.div`
  ${GridVariables};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.backgroundLight};
  display: grid;
  grid-template-areas: ${GridTemplateAreas.mobile};
  grid-template-columns: ${GridLayout.mobile.columns};
  gap: ${GridLayout.mobile.gap};
  padding-inline: ${Spacers.BASE}rem;
  padding-block: ${Spacers.BASE}rem;
  border-top: 1px solid ${({ theme }) => theme.colors.backgroundAccent};
  z-index: 99;

  ${breakpoints.desktopOrBigger} {
    grid-template-columns: ${GridLayout.desktop.columns};
    grid-template-areas: ${GridTemplateAreas.desktop};
    gap: ${GridLayout.desktop.gap};
    padding-inline: 0;
  }
`;

export const BottomContent = styled.div`
  display: grid;
  grid-area: content;
`;

export const AdminPageContainer = styled.div`
  padding-right: ${Spacers.LG}rem;
  display: flex;
  flex-direction: column;
`;
